import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '../../../../node_modules/@angular/router';
import { CreateAccountComponent } from '../create-account/create-account.component';
import { PlayerService } from '../../services/player.service';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 's18-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  forwardTo: string = '';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private playerService: PlayerService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.forwardTo = '';
    let dialogRef = this.dialog.open(CreateAccountComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.playerService.getLoggedInPlayerInfo();
        // Honor a pending forward_url first (e.g. the user came from /join/:group_id
        // and created an account). Without this the new player was always dropped on
        // the dashboard and never returned to the page that sent them to sign up.
        const forwardUrl = this.localStorageService.get("forward_url");
        if (forwardUrl) {
          this.localStorageService.set("forward_url", null);
          this.router.navigateByUrl(forwardUrl);
        } else if (this.router.url.indexOf("league") > -1) {
          this.router.navigateByUrl("/upgrade/payment/League/2/0");
        } else if (this.router.url.indexOf("tournament") > -1) {
          this.router.navigateByUrl("/upgrade/payment/tournament/4/1");
        } else if (this.router.url.indexOf("trip") > -1) {
          this.router.navigateByUrl("/upgrade/payment/trip/5/15");
        } else {
          this.router.navigateByUrl("/dashboard");
        }
      }
    });
  }

}
